/**
 * (車輌マスタメンテナンス 新規登録/詳細) 車輌内装キズチェック
 */

/* Import Modules */
import $ from "jquery";

/* Import Variables */
import {
  interiorCheckRow,
  interiorCheckCol,
} from "../../../../src/compositions/rentContract/carScratches/interior";

/* Define Scripts */
/**
 * (車輌マスタメンテナンス 新規登録/詳細) 車輌内装キズ情報表示処理
 * @param interiorCheck
 */
export const vehicleScratchesInfoInitialDisplayByInteriorCheck = (
  interiorCheck
) => {
  const interiorCheckArray = interiorCheck.split(",");
  let index = 0;
  for (let i = 1; i <= interiorCheckRow; i++) {
    for (let j = 1; j <= interiorCheckCol; j++) {
      let elementId = "#interior_" + i + "_" + j;
      $(elementId).text(interiorCheckArray[index]);
      let elementModalId = "#m_interior_" + i + "_" + j;
      $(elementModalId).text(interiorCheckArray[index]);
      ++index;
    }
  }
};

/**
 * (車輌マスタメンテナンス 新規登録/詳細) キズ情報更新
 * @param row
 * @param col
 */
export const setInteriorCheckByCarCheckMasterModal = (
  row: number,
  col: number
) => {
  let elementId = "#m_interior_" + row + "_" + col;
  $(elementId).text($("input[name='interior-radio']:checked").val());
};

/**
 * (車輌マスタメンテナンス 新規登録/詳細) キズ情報反映
 */
export const setInteriorDataByCarCheckMasterModal = () => {
  let checkValue = "";
  for (let i = 1; i <= interiorCheckRow; i++) {
    for (let j = 1; j <= interiorCheckCol; j++) {
      /* ElementIdを取得 */
      let elementId = "#interior_" + i + "_" + j;
      let elementModalId = "#m_interior_" + i + "_" + j;
      /* カンマベースの入力値を取得 */
      checkValue += $(elementModalId).text();
      checkValue += ",";
      /* キズ情報 コピー処理 */
      $(elementId).text($(elementModalId).text());
    }
  }
  checkValue = checkValue.slice(0, -1);

  /* Move Interior Value */
  $("#interior_check").val(checkValue);

  /* Model Close */
  $("#interior_close_button").trigger("click");
};

/**
 * グローバル関数を定義
 */
(window as any).vehicleScratchesInfoInitialDisplayByInteriorCheck =
  vehicleScratchesInfoInitialDisplayByInteriorCheck;
(window as any).setInteriorCheckByCarCheckMasterModal =
  setInteriorCheckByCarCheckMasterModal;
(window as any).setInteriorDataByCarCheckMasterModal =
  setInteriorDataByCarCheckMasterModal;
